package de.connect2x.timmy.brandings.aokTheme

import androidx.compose.material3.ColorScheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.ui.graphics.Color
import de.connect2x.trixnity.messenger.compose.view.theme.ThemeDarkColorScheme

object ThemeDarkColorSchemeWcImpl : ThemeDarkColorScheme {
    override fun create(accentColor: Color): ColorScheme {
        return darkColorScheme(
            primary = md_theme_dark_primary,
            onPrimary = md_theme_dark_onPrimary,
            primaryContainer = md_theme_dark_primaryContainer,
            onPrimaryContainer = md_theme_dark_onPrimaryContainer,
            secondary = md_theme_dark_secondary,
            onSecondary = md_theme_dark_onSecondary,
            secondaryContainer = md_theme_dark_secondaryContainer,
            onSecondaryContainer = md_theme_dark_onSecondaryContainer,
            tertiary = md_theme_dark_tertiary,
            onTertiary = md_theme_dark_onTertiary,
            tertiaryContainer = md_theme_dark_tertiaryContainer,
            onTertiaryContainer = md_theme_dark_onTertiaryContainer,
            error = md_theme_dark_error,
            onError = md_theme_dark_onError,
            errorContainer = md_theme_dark_errorContainer,
            onErrorContainer = md_theme_dark_onErrorContainer,
            background = md_theme_dark_background,
            onBackground = md_theme_dark_onBackground,
            surface = md_theme_dark_surface,
            onSurface = md_theme_dark_onSurface,
            surfaceVariant = md_theme_dark_surfaceVariant,
            onSurfaceVariant = md_theme_dark_onSurfaceVariant,
            outline = md_theme_dark_outline,
            outlineVariant = md_theme_dark_outlineVariant,
            scrim = md_theme_dark_scrim,
            inverseSurface = md_theme_dark_inverseSurface,
            inverseOnSurface = md_theme_dark_inverseOnSurface,
            inversePrimary = md_theme_dark_inversePrimary,
            surfaceDim = md_theme_dark_surfaceDim,
            surfaceBright = md_theme_dark_surfaceBright,
            surfaceContainerLowest = md_theme_dark_surfaceContainerLowest,
            surfaceContainerLow = md_theme_dark_surfaceContainerLow,
            surfaceContainer = md_theme_dark_surfaceContainer,
            surfaceContainerHigh = md_theme_dark_surfaceContainerHigh,
            surfaceContainerHighest = md_theme_dark_surfaceContainerHighest,
        )
    }
}
